"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6533],{

/***/ 16533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97133);
/* harmony import */ var _prezzee_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34906);
/* harmony import */ var _prezzee_components__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_prezzee_components__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _prezzee_tokens__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53126);
/* harmony import */ var _prezzee_tokens__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_prezzee_tokens__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67814);
/* harmony import */ var _RetailerList__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90330);
/* harmony import */ var _SearchBar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50735);








var style = {
    dialog: /*#__PURE__*/ (0,_emotion_css__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)("[role='dialog']{max-width:800px;width:100%;height:100%;@media (min-height:864px){max-height:800px;}}"),
    retailerContainer: /*#__PURE__*/ (0,_emotion_css__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)("padding:", _prezzee_tokens__WEBPACK_IMPORTED_MODULE_3__.spacing.spacing06, ";padding-top:0;display:flex;flex-direction:column;"),
    stickySearchHeader: /*#__PURE__*/ (0,_emotion_css__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)("position:-webkit-sticky;position:sticky;top:0;background-color:white;padding-top:", _prezzee_tokens__WEBPACK_IMPORTED_MODULE_3__.spacing.spacing06, ";padding-bottom:", _prezzee_tokens__WEBPACK_IMPORTED_MODULE_3__.spacing.spacing04, ";z-index:9;"),
    close: /*#__PURE__*/ (0,_emotion_css__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)("width:30px;height:30px;border-radius:50%;background-color:", _prezzee_tokens__WEBPACK_IMPORTED_MODULE_3__.colors.lilac50, ";position:absolute;right:0;top:", _prezzee_tokens__WEBPACK_IMPORTED_MODULE_3__.spacing.spacing06, ";"),
    title: /*#__PURE__*/ (0,_emotion_css__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)("margin-bottom:", _prezzee_tokens__WEBPACK_IMPORTED_MODULE_3__.spacing.spacing05, " !important;padding-right:35px;")
};
var RetailerListDialog = function(param) {
    var retailerList = param.retailerList, isOpen = param.isOpen, handleRetailerListClose = param.handleRetailerListClose;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""), searchTerm = ref[0], setSearchTerm = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!isOpen && searchTerm) {
            setSearchTerm("");
        }
    }, [
        isOpen,
        searchTerm
    ]);
    var handleSearchChange = function(e) {
        var target = e.currentTarget;
        setSearchTerm(target.value.toLocaleLowerCase().replace(/[^\w\s]/g, "\\$&"));
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_prezzee_components__WEBPACK_IMPORTED_MODULE_2__.Dialog, {
        open: isOpen,
        onClose: handleRetailerListClose,
        className: style.dialog,
        "aria-labelledby": "retailer-list-dialog-title",
        "aria-describedby": "retailer-list-dialog-description",
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
            className: style.retailerContainer,
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
                    className: style.stickySearchHeader,
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("button", {
                            onClick: handleRetailerListClose,
                            className: style.close,
                            title: "Close retailer list dialog",
                            "aria-label": "Close retailer list dialog",
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_4__.FontAwesomeIcon, {
                                icon: [
                                    "fas",
                                    "times"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_prezzee_components__WEBPACK_IMPORTED_MODULE_2__.Typography, {
                            variant: "h4",
                            component: "h3",
                            id: "retailer-list-dialog-title",
                            className: style.title,
                            children: "Swap for these retailers"
                        }),
                        retailerList.length >= 16 && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_SearchBar__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            placeholder: "Search brands",
                            onChange: handleSearchChange
                        })
                    ]
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_RetailerList__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    retailers: retailerList,
                    searchTerm: searchTerm
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (RetailerListDialog);


/***/ })

}]);